"use client";
import { ApolloLink } from "@apollo/client";
import {
  ApolloNextAppProvider,
  ApolloClient,
  InMemoryCache,
  SSRMultipartLink
} from "@apollo/client-integration-nextjs";
import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs";

function makeClient() {
  const graphqlUrl =
    process.env.NEXT_PUBLIC_CLIENT_GRAPHQL_URL ||
    "https://admin.cneaustralia.op-dev.sbmclient.com/api/graphql";

  const uploadLink = new UploadHttpLink({
    uri: graphqlUrl,
    headers: {
      "Apollo-Require-Preflight": "true"
    },
    credentials: "include"
  });

  return new ApolloClient({
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {}
        }
      }
    }),
    link:
      typeof window === "undefined"
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: true
            }),
            uploadLink
          ])
        : uploadLink,
    // Add error logging
    defaultOptions: {
      watchQuery: {
        errorPolicy: "all"
      },
      query: {
        errorPolicy: "all"
      },
      mutate: {
        errorPolicy: "all"
      }
    }
  });
}

export function ApolloWrapper({ children }: React.PropsWithChildren) {
  return <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>;
}
